import { CacheService } from './../../services/cache.service';
import { DIMBO_CONSTANT } from './../../utils/constant';
import { TranslatePipe } from './../../pipes/translate.pipe';
import { TranslateService } from  '@ngx-translate/core';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { VehicleInfo } from 'src/app/model/vehicle-info';
import { VehicleInfoService } from 'src/app/services/vehicle-info.service';
import { ToastrService } from 'ngx-toastr';
import { AdditionalInfoDialogBoxComponent } from '../additional-info-dialog-box/additional-info-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { VehicleInfoDialogComponent } from '../vehicle-info-dialog/vehicle-info-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-vehicle-info',
  templateUrl: './vehicle-info.component.html',
  styleUrls: ['./vehicle-info.component.scss']
})
export class VehicleInfoComponent implements OnInit, OnChanges {

  vehicleinfo: any;
  vehicleInfoDialogBoxRef: any;
  isReadOnly: boolean = false;
  @Output()
  onVeichleUpdate: EventEmitter<{ isVehicleUpdated: boolean}> = new EventEmitter(); 
  @Input() isAdditionalInfoUpdated: boolean;
  noDataFound: boolean;

  vehicleBrand: string;
  vehicleColor: string;
  vehicleModel: string;
  vehicleVin: string;
  vehicleRegistrationNo: string;
  vehicleRegistrationDate: string;
  vehicleMileageValue: string;
  vehicleMileageUnit: string;
  imageBasePath : string;
  imageFullPath:string;
  
  vilocale: any;

  constructor(
    private translationService: TranslateService,
    private translatePipe: TranslatePipe,
    private vehicleInfoService:VehicleInfoService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private cacheService: CacheService,
    private spinner: NgxSpinnerService
    ) { }

  ngOnInit(): void {
    this.imageBasePath ="../../../assets/images/";
  
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER) === true || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER) === true ) {
      this.isReadOnly = true; 
    } else {
      this.isReadOnly = false; 
    }
    this.getVehicleInfo();
    // this.vilocale=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL);
    this.vilocale=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE);  //DMBR-47: changed path for getting locale language
  }

  ngOnChanges() {
    if (this.isAdditionalInfoUpdated) {
      this.isAdditionalInfoUpdated = false;
    //  console.log('after updating addition info...');
      this.getVehicleInfo();
      
    }
  }

  getVehicleInfo() {
    this.spinner.show();
    this.vehicleInfoService.getVehicleInfo()
    .subscribe(response => {
     // console.log(response);
      if(response) {
        this.noDataFound = false;
        this.vehicleinfo = response;
        this.vehicleBrand = response.brand;
        this.vehicleColor = response.color;
        this.vehicleModel = response.model;
        this.vehicleVin = response.vin;
        this.vehicleRegistrationNo = response.registration;
        this.vehicleRegistrationDate = response.registrationDate;
        this.vehicleMileageValue = response.mileageValue
        this.vehicleMileageUnit = response.mileageUnit;
        // Storing vehicle related info in the cache

        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_OV_LEGACY, response.isOvLegacy); 
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_BRAND, this.getBrand(response.brand));
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_REGISTRATION, response.registration);
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE, response.registrationDate);
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE, response.mileageValue);      
        if(response.mileageUnit==='miles' || response.mileageUnit==='MILES' || response.mileageUnit==='Miles'){
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT, 'mi');
        }else {
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT, response.mileageUnit);
        }
        if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL)===undefined){
        this.onVeichleUpdate.emit({isVehicleUpdated: true});
        }
        this.spinner.hide();
      } else {
        this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.VehicleInfo.vin'));
        this.noDataFound = true;
      }
      this.imageFullPath=this.imageBasePath+this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CIN_BRAND)+".svg";
      if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL)!==undefined){
      if(!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH)){
        this.vehicleMileageValue='0';
        this.vehicleMileageUnit=this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL);
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE, '0'); 
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT, this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL));
    }
  }
      }, error => {
        this.spinner.hide();
        this.noDataFound = true;
        if (error && error.status && (error.status === 404 || error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503)) {
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.VehicleInfo.vin'));
      } else {
          this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'));
      }
       
      });
    
  }

  onVehicleInfoEdit(){
    let isCreateServiceScope = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE);
    if(isCreateServiceScope) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.vehicleEdit.error'), this.translationService.instant('dimbo.i18n.message.toastr.warning'));
      return;
    }
   // console.log('open additional popup');
    this.openDialogBox('POPUP_VIEW',this.vehicleinfo);
  }
  openDialogBox(eventName: string, vehicleinfo?: any) {
   // console.log('here...');
    const popupData = { eventName: eventName, vehicleinfo: vehicleinfo };
    this.vehicleInfoDialogBoxRef = this.matDialog.open(VehicleInfoDialogComponent, {
      disableClose: true,
      minWidth: '425px',
      minHeight: '370px',
      data: popupData
      //backdropClass: 'custom-dialog',
     // panelClass: 'custom-class'
    });

    this.vehicleInfoDialogBoxRef.afterClosed().subscribe(result => {
      if (result) {
       if (result.event.eventName === 'POPUP_OK') {
          this.getVehicleInfo();
         // this.onVeichleUpdate.emit({isVehicleUpdated: true});
                     }
          else{
            this.getVehicleInfo();
                                 
          }
      }
      
    });
  }

  getBrand(param: string): string {
    let brand: string = '';
    switch (param) {
      case 'Peugeot':
        brand = 'AP';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      
      case 'Citroen':
        brand = 'AC';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;

      case 'Ds':
          brand = 'DS';
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
          break;
          
      case 'Opel':
        brand = 'OV';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, 'OP');
        break;

      case 'Vauxhall':
        brand = 'OV';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, 'VX');
        break;
        
      case 'OPEL/VAUXHALL':
        brand = 'OV';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, 'VX');
        break;

      case 'CHRYSLER':
        brand = 'CY';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'DODGE':
        brand = 'DG';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'JEEP':
        brand = 'JE';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'RAM':
        brand = 'RM';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'ALFA ROMEO':
        brand = 'AR';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'FIAT':
        brand = 'FT';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'LANCIA':
        brand = 'LA';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'ABARTH':
        brand = 'AH';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      case 'FIAT PRO':
      case 'Fiat Professional':
        brand = 'FO';
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CIN_BRAND, brand);
        break;
      default:
        break;
    }
    return brand;
  }

  
}
